const INTEGER_PORTION_THRESHOLD = 5;
const FIXED_LONG_DECIMAL = 4;
const FIXED_SHORT_DECIMAL = 2;

export const isNumeric = (value: unknown): boolean => {
  if (typeof value === 'number' && isFinite(value)) {
    return true;
  }

  if (
    typeof value === 'string' &&
    !isNaN(parseFloat(value)) &&
    isFinite(Number(value))
  ) {
    return true;
  }

  return false;
};

// if the integer portion >= 5, show 2 decimals, if integer portion < 5 then default to 4 decimals
export const formatDecimalPlaces = (value: string | number) => {
  if (!isNumeric(value)) {
    return value;
  }

  const numberValue = Number(value);

  const integerPortion = Math.floor(Math.abs(numberValue));
  const decimals =
    integerPortion >= INTEGER_PORTION_THRESHOLD
      ? FIXED_SHORT_DECIMAL
      : FIXED_LONG_DECIMAL;

  return numberValue.toFixed(decimals);
};
